import React from 'react';
import {WithStyles, withStyles} from '@material-ui/core/styles/index';
import IconButton from '@material-ui/core/IconButton/index';
import Tooltip from '@material-ui/core/Tooltip';
import createStyles from "@material-ui/core/styles/createStyles";

const styles = () => createStyles({
  root: {
    padding: '4px',
    marginLeft: '12px',
  },
});

interface Props extends WithStyles<typeof styles> {
  icon: JSX.Element;
  tooltip?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
}

const ActionBarIconButton = (props: Props) => {
  const { classes, icon, tooltip, onClick, disabled } = props;

  // @ts-ignore
  const content = <IconButton size="small" className={classes.root} onClick={onClick} disabled={disabled}>{icon}</IconButton>;

  if (tooltip && tooltip !== '') {
    return (
      <Tooltip title={tooltip}>
        {content}
      </Tooltip>
    );
  }

  return content;
};

export default withStyles(styles)(ActionBarIconButton);
